<script setup lang="ts">
import type { ResolvedMonospacePrimitiveField } from '#layers/data-model/public';
import type { RenderFieldDisplayProps } from './types';
import { isNil } from '#layers/base/public';
import { usePrimitiveFieldDisplay } from '#layers/blocks/composables/use-field-display';
import { useStableRenderBlockProps } from './use-stable-render-block-props';

interface RenderPrimitiveFieldDisplayProps extends RenderFieldDisplayProps {
	field: ResolvedMonospacePrimitiveField;
}

defineOptions({
	inheritAttrs: false,
});

const props = defineProps<RenderPrimitiveFieldDisplayProps>();

const { block, props: displayProps, isResolving } = usePrimitiveFieldDisplay(() => props.field);
const blockProps = useStableRenderBlockProps(() => ({
	...displayProps.value,
	fieldId: props.fieldId,
	value: props.value,
	item: props.item,
	root: props.root,
}));
</script>

<template>
	<DDisplayValueEmpty
		v-show="isNil(value) && !isResolving"
	/>
	<!--
		Hide via a wrapper we own, not the block: blocks may set `inheritAttrs: false`,
		dropping anything we'd thread through attrs to hide them and leaving their own
		empty fallback visible alongside ours. `display: contents` keeps it layout-neutral.
	-->
	<div v-if="block" v-show="!isNil(value)" class="contents">
		<BlockRender
			:block
			:props="blockProps"
			v-bind="$attrs"
		/>
	</div>
</template>
